import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  setFavorite,
  unsetFavorite,
} from "../../../../../redux/actions/favorites";
import { IRootState } from "../../../../../redux/types";
import { isStandalone } from "@/contexts/shared/utils/IsStandAlone";

function useDetailActions(setFavoriteState: any) {
  const dispatch = useDispatch();
  const { t } = useTranslation(["global"]);

  const { resourceSelected } = useSelector(
    (state: IRootState) => state.resource
  );

  const [msgCopy, setMsgCopy] = useState("");

  const handleDownload = (resource_id: number) => {
    const URL = `${import.meta.env.VITE_API_URL}/resources/download/`;

    if (isStandalone()) {
      console.log("download in standalone");
      const link = document.createElement("a");
      link.href = URL + resource_id;
      link.download =
        (resourceSelected?.alias ?? "") + "." + (resourceSelected?.ext ?? "") ||
        "resource";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      console.log("download in browser");
      window.open(URL + resource_id);
    }
  };

  const hasDescription =
    resourceSelected?.description && resourceSelected?.description !== "";

  const handleCopyText = () => {
    if (!hasDescription) return null;

    navigator.clipboard.writeText(resourceSelected.description || "");
    setMsgCopy(t("text-copied-success"));
    setTimeout(() => {
      setMsgCopy("");
    }, 5000);
  };

  const handleFavorite = (resource_id: number) => (state: boolean) => {
    if (state) {
      dispatch(
        setFavorite({
          id: resource_id,
          type: "resource",
        })
      );
    } else {
      dispatch(
        unsetFavorite({
          id: resource_id,
          type: "resource",
        })
      );
    }
    setFavoriteState(state);
  };

  return {
    hasDescription,
    msgCopy,
    handleDownload,
    handleCopyText,
    handleFavorite,
  };
}

export default useDetailActions;
